module.exports = __webpack_public_path__ + "adobe.eb0a102cccd92e5c5f008c2aeb5f323e.svg";